<script lang="ts">
    import type {MessageDocument} from "./Types";
    import FormattedText from "./FormattedText.svelte";
    import Document from "./Document.svelte";

    export let entity: MessageDocument
    export let attachments: ChatMessageAttachmentData[]
</script>
<div class="alert alert-warning m-0">
    Документ<br/>
    <FormattedText entity={entity.caption}/>
    <Document entity={entity.document} {attachments}></Document>
</div>
